import sdk, { type SalonStockerHttpTypes } from "@repo/api-sdk";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";

export function sellerOfferQuery(
  id: string,
  query?: SalonStockerHttpTypes.StoreSellerOfferParams
) {
  return queryOptions({
    queryKey: queryKeys.detail(id, query),
    queryFn: () => sdk.store.sellerOffer.retrieve(id, query),
    staleTime: 60
  });
}

export function useSellerOffer(
  id: string,
  query?: SalonStockerHttpTypes.StoreSellerOfferParams,
  options?: {
    enabled?: boolean;
  }
) {
  return useQuery({
    ...sellerOfferQuery(id, query),
    ...options
  });
}
